import React, { useState, useEffect, useMemo } from 'react';
const FeeSimulator = ({volumeDaily, volumeWeekly, volumeMonthly, volumeSemiAnnually, volumeAnnually}) => {

  const FEE_PERCENT = 6;
  const breakdownPercents = {'Reflection Reward': 1, 'UFO Buy & Burn': 1, 'PTGC Buy & Burn': 1, 'UFO Liquidity Provider': 3};
  const breakdownLabels = {'Reflection Reward': "allocated to reflection", 'UFO Buy & Burn': "allocated to UFO buy & burn", 'PTGC Buy & Burn': "allocated to PTGC buy & burn", 'UFO Liquidity Provider': "allocated to UFO LPing"};
  const multiplierOptions = [{ label: "1x", value: 1 }, { label: "2x", value: 2 }, { label: "10x", value: 10 }, { label: "20x", value: 20 }, { label: "50x", value: 50 }, { label: "100x", value: 100 }];

  const [timeframe, setTimeframe] = useState(1);
  const [multiplier, setMultiplier] = useState(1);
  const volumeMap = {1: volumeDaily, 7: volumeWeekly, 30: volumeMonthly, 180: volumeSemiAnnually, 365: volumeAnnually};

  const currentVolume = volumeMap[timeframe] || 1;
  const valueGeneratedPerDay = (currentVolume * FEE_PERCENT) / 100;
  const totalValueGenerated = parseFloat(valueGeneratedPerDay * multiplier).toFixed(0);

  const feeBreakdown = useMemo(() => {
    const breakdown = {};
    Object.entries(breakdownPercents).forEach(([key, percent]) => {
      breakdown[key] = (currentVolume * percent / 100) * multiplier;
    });
    return breakdown;
  }, [currentVolume, timeframe, multiplier]);
  
  return (
  <>
    <div className="bottomSliderRight ">
      <div className="bSRIN overHide">
        <div className="snPortal borderBottom">
          <div className=" align-items-center">
              <div className=" w-100">
                  <div className="d-flex flex-wrap justify-content-between gap-2 align-items-center mb-2">
                    <span className="fInter goldFont">Volume Calculator</span>
                  <div className="rTabs mt-2">
                    <button className={`inputrightCenter ${timeframe === 1 ? 'active' : ''}`} onClick={() => setTimeframe(1)}>1D</button>
                    <button className={`inputrightCenter ${timeframe === 7 ? 'active' : ''}`} onClick={() => setTimeframe(7)}>1W</button>
                    <button className={`inputrightCenter ${timeframe === 30 ? 'active' : ''}`} onClick={() => setTimeframe(30)}>1M</button>
                    <button className={`inputrightCenter ${timeframe === 180 ? 'active' : ''}`} onClick={() => setTimeframe(180)}>6M</button>
                    <button className={`inputrightCenter ${timeframe === 365 ? 'active' : ''}`} onClick={() => setTimeframe(365)}>1Y</button>
                  </div>
              </div>
            <div className="row ">
                <div className="col-md-6" >
                  <span className="fInter">Daily Transaction Volume:</span>
                    <div className="dollorVal mt-0">
                      <span className="dollor">$</span>
                      <span className="val f34">{parseFloat(currentVolume * multiplier).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                    </div>
                  </div>
                <div className="col-md-6" >
                  <span className="fInter textgreen">Total Fees {FEE_PERCENT}%:</span>
                    <div className="dollorVal mt-0">
                      <span className="dollor">$</span>
                      <span className="val f34">{parseFloat(totalValueGenerated).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          
            <label className="fInter d-block mb-1 mt-2">Multiplier (e.g.  2, 10, 20 )</label>
            <div className="d-flex">
              <div className="relative rTabs gap-1">
                {multiplierOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`multiplier-btn ${
                      multiplier === option.value ? "active" : ""
                    }`}
                    onClick={() => setMultiplier(option.value)}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
        </div>

        <div className="borderBottom0 borderBottom  ">
          <div className=" ">
            <div className="row m-0">
              {Object.entries(feeBreakdown).map(([key, value]) => (
                <div className="col-md-6 p-0" key={key}>
                  <div className="somespace">
                    <div className="snPortal bggrey bggrey2 px-4 py-3 mb-2">
                      <div>
                        <div className="fInter d-flex gap-0 align-items-center justify-content-between">
                          {key}
                        </div>
                        <div className="dollorVal mt-0 mb-0">
                          <span className="dollor">$</span>
                          <span className="val f28">{parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </div>
                        <span className="fInter">
                          {breakdownPercents[key]}%  {breakdownLabels[key]}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default FeeSimulator;
